'use client';

import { type ReactNode, useId } from 'react';
import { cn } from '@/lib/cn';

export interface CollapseFadeProps {
    showMoreLabel?: string;
    showLessLabel?: string;
    active?: boolean;
    mdActive?: boolean;
    children: ReactNode;
    className?: string;
}
export function CollapseFade({ showMoreLabel = 'Show more', showLessLabel = 'Show less', active, mdActive, children, className }: CollapseFadeProps) {
    const id = useId();

    return (
        <>
            <div
                className={cn(
                    'fade-collapse peer rounded-none has-checked:overflow-visible',
                    {
                        'not-has-checked:mask-fade-bottom collapse': active && mdActive,
                        'md:not-has-checked:mask-image-none': active && !mdActive,
                    },
                    className
                )}
            >
                <input
                    id={id}
                    type="checkbox"
                    className="peer hidden"
                    onChange={(e) => {
                        const isChecked = e.currentTarget.checked;
                        const container = e.currentTarget.closest('.fade-collapse');
                        setTimeout(() => {
                            if (!container || isChecked) {
                                return;
                            }
                            container.scrollIntoView({ behavior: 'smooth', block: 'start' });
                        }, 100);
                    }}
                />

                <div data-testid="fade-collapse-content" className="collapse-content visible content-visible">
                    {children}
                </div>
            </div>
            <label
                data-testid="show-more-button"
                htmlFor={id}
                className={cn(
                    'btn btn-primary w-34 h-13 mt-14 md:mt-10 mx-auto content-center peer-has-checked:[&_.more]:hidden peer-has-checked:[&_.less]:inline not-peer-has-checked:[&_.more]:inline not-peer-has-checked:[&_.less]:hidden',
                    {
                        hidden: !active && !mdActive,
                        block: active && mdActive,
                        'block md:hidden': active && !mdActive,
                        'hidden md:block': !active && mdActive,
                    }
                )}
            >
                <span className="more">{showMoreLabel}</span>
                <span className="less">{showLessLabel}</span>
            </label>
        </>
    );
}
